(function () {
  function initCarousel(root) {
    if (root.dataset.kReady) return;
    root.dataset.kReady = '1';
    var track = root.querySelector('[data-k-track]');
    var slides = root.querySelectorAll('[data-k-slide]');
    var tabs = root.querySelectorAll('[data-k-tab]');
    var count = slides.length;
    if (count < 2) return;
    var ms = (parseInt(root.dataset.interval, 10) || 6) * 1000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, timer = null;

    function show(n, restart) {
      i = (n + count) % count;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      tabs.forEach(function (t, k) {
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        // restart the progress-bar animation
        var bar = t.querySelector('.k-hero__progress span');
        if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      });
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      if (restart !== false) start();
    }
    function start() {
      clearInterval(timer);
      if (reduce || root.classList.contains('is-paused')) return;
      timer = setInterval(function () { show(i + 1, false); }, ms);
    }

    tabs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.dataset.kTab, 10)); }); });
    var prev = root.querySelector('[data-k-prev]'), next = root.querySelector('[data-k-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });

    // Theme editor: jump to the slide being edited and hold it there
    document.addEventListener('shopify:block:select', function (e) {
      var idx = Array.prototype.indexOf.call(slides, e.target);
      if (idx > -1) { root.classList.add('is-paused'); clearInterval(timer); show(idx, false); }
    });
    document.addEventListener('shopify:block:deselect', function () { root.classList.remove('is-paused'); start(); });

    if (reduce) root.classList.add('is-paused');
    show(0);
  }
  function boot() { document.querySelectorAll('[data-k-carousel]').forEach(initCarousel); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

(function () {
  function initGallery(root) {
    if (root.dataset.kReady) return;
    root.dataset.kReady = '1';
    var track = root.querySelector('[data-k-gtrack]');
    if (!track) return;
    var slides = root.querySelectorAll('[data-k-gslide]');
    var thumbs = root.querySelectorAll('[data-k-gthumb]');
    var prev = root.querySelector('[data-k-gprev]'), next = root.querySelector('[data-k-gnext]');
    var cur = root.querySelector('[data-k-gcur]');
    var i = 0;
    function go(n) { n = Math.max(0, Math.min(slides.length - 1, n)); track.scrollTo({ left: n * track.clientWidth }); }
    function update() {
      i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (cur) cur.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      thumbs.forEach(function (t, k) {
        t.setAttribute('aria-current', k === i ? 'true' : 'false');
        if (k === i && t.parentNode) t.parentNode.scrollLeft = t.offsetLeft - t.parentNode.clientWidth / 2 + t.clientWidth / 2;
      });
    }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); });
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.kGthumb, 10)); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
    });
    update();
  }
  function boot() { document.querySelectorAll('[data-k-gallery]').forEach(initGallery); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
